import template from './addedItem.html';
import controller from './addedItem.controller';
import './addedItem.scss';

let addedItemComponent = {
  restrict: 'E',
  bindings: {
    value: '@',
    remove: '&'
  },
  template,
  controller
};

export default addedItemComponent;
